<script>
import {defineComponent} from 'vue'
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue";
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";
import IconPaymentVisa from "@js/components/Icons/IconPaymentVisa.vue";
import IconPaymentMasterCard from "@js/components/Icons/IconPaymentMasterCard.vue";
import IconPaymentMir from "@js/components/Icons/IconPaymentMir.vue";
import IconPaymentSbp from "@js/components/Icons/IconPaymentSbp.vue";
import IconPaymentMaestro from "@js/components/Icons/IconPaymentMaestro.vue";
import {useCallbackStore} from "@js/store/CallbackStore.js";

export default defineComponent({
    name: "PaymentPage",
    components: {
        MobileTopBar,
        Breadcrumbs,
        IconPaymentVisa,
        IconPaymentMasterCard,
        IconPaymentMir,
        IconPaymentSbp,
        IconPaymentMaestro
    },
    setup(){
        const callbackStore = useCallbackStore()

        return {callbackStore}
    }
});
</script>

<template>
    <MobileTopBar/>
    <div class="container">
        <Breadcrumbs/>
        <h1 class="text-2xl md:text-3xl font-semibold mb-6">
            Способы оплаты металлопроката
        </h1>

     <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
         <!-- Способы оплаты -->
         <section class="bg-grayBg rounded-3xl px-5 md:px-8 py-8">
             <h2 class="text-xl md:text-2xl font-semibold mb-4">Доступные способы оплаты</h2>
             <p class="mb-4">Мы предлагаем все современные и удобные формы оплаты:</p>
             <ul class="list-disc list-inside space-y-2 mb-4">
                 <li>Наличными в офисе или при доставке.</li>
                 <li>Банковской картой в офисе или онлайн.</li>
                 <li>Переводом по СБП (Система Быстрых Платежей).</li>
                 <li>Безналичным расчетом для юридических лиц с НДС или без НДС.</li>
             </ul>
             <div class="flex items-center gap-4">
                 <IconPaymentVisa class="h-10 w-auto"/>
                 <IconPaymentMasterCard class="h-10 w-auto"/>
                 <IconPaymentMir class="h-10 w-auto"/>
                 <IconPaymentMaestro class="h-10 w-auto"/>
                 <IconPaymentSbp class="h-10 w-auto"/>
             </div>
         </section>

         <!-- Онлайн-оплата -->
         <section class="bg-grayBg rounded-3xl px-5 md:px-8 py-8">
             <h2 class="text-xl md:text-2xl font-semibold mb-4">Оплата онлайн</h2>
             <p class="mb-4">
                 Для удобства наших клиентов мы предоставляем возможность оплатить заказ онлайн с помощью банковской карты или перевода по СБП.
             </p>
             <p class="mb-4">
                 После оформления заказа наш менеджер свяжется с вами для подтверждения и отправит ссылку на оплату по email или в мессенджер.
             </p>
             <p class="text-sm text-gray-600">
                 Все онлайн-платежи проходят через защищенный платежный шлюз, соответствующий требованиям безопасности PCI DSS.
             </p>
         </section>

         <!-- Безналичный расчет -->
         <section class="bg-grayBg rounded-3xl px-5 md:px-8 py-8">
             <h2 class="text-xl md:text-2xl font-semibold mb-4">Оплата для юридических лиц</h2>
             <p class="mb-4">
                 Компания «Металлопрокат-1» работает с юридическими лицами по безналичному расчету, как с НДС, так и без. Мы подготовим все необходимые документы: счёт, счёт-фактуру, товарную накладную.
             </p>
             <ul class="list-disc list-inside space-y-2">
                 <li>Согласуйте заказ с менеджером.</li>
                 <li>Получите счет на оплату.</li>
                 <li>После поступления средств мы приступим к сборке и отгрузке металлопроката.</li>
             </ul>
         </section>

         <!-- Вопросы и гарантии -->
         <section class="bg-grayBg rounded-3xl px-5 md:px-8 py-8">
             <h2 class="text-xl md:text-2xl font-semibold mb-4">Гарантии и безопасность</h2>
             <p class="mb-4">
                 Мы гарантируем прозрачность всех платежей и безопасность обработки ваших данных. Все платежные данные защищены и не сохраняются на наших серверах.
             </p>
             <p>
                 Если у вас возникли вопросы по оплате — свяжитесь с нами по телефону или через форму обратной связи. Наши менеджеры всегда готовы помочь.
             </p>
             <button @click.prevent="callbackStore.showBaseCallbackPopup"
                     class="max-md:w-full mt-4 flex justify-center items-center text-center text-white hover:text-baseColor border-2 border-baseColor bg-baseColor md:hover:bg-transparent font-bold rounded-lg text-sm px-6 py-2.5 focus:outline-none transition cursor-pointer uppercase">
                 Узнать подробнее
             </button>
         </section>
     </div>
    </div>
</template>

<style scoped>
/* При необходимости добавьте кастомные стили */
</style>
